import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PrimeNGConfigType, providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';

import { AdvaniaThemeService } from '../services/advania-theme.service';
import { AdvaniaTheme } from '../theme';
import { provideIcons } from './icons.provider';

const defaults: PrimeNGConfigType = {
    license:
        'eyJpZCI6ImU5YWFhMzhjLWFmZmUtNDhhNy04YTE1LTkwMGYyODExNmI3NCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzg1MjMzMTg5LCJleHAiOjE4MTY3NjkwMTB9.lwCH8P0oHshQz3XL8uX6BNi6rFAP1F2bSArUsYHqZUTkciQs34syoFTxKu9layUauTT1Not8xuxXUqgNheo-Cg',
    theme: {
        preset: AdvaniaTheme,
        options: {
            darkModeSelector: '.app-dark',
        },
    },
    ripple: false,
    inputVariant: 'outlined',
    translation: {},
    pt: {
        accordion: {
            root: '[&>.p-accordionpanel:last-child]:!border-b-0 [&_.p-ink]:!hidden',
        },
        tabs: {
            root: 'p-ripple-disabled [&_.p-tab]:!min-w-0 [&_.p-tab]:!truncate [&_.p-tab]:!font-serif [&_.p-tab]:!text-xl [&_.p-tab]:!font-bold',
        },
        popover: {
            root: '[&:before]:!hidden [&:after]:!hidden',
        },
        overlaybadge: {
            pcBadge: {
                root: '!pt-px',
            },
        },
    },
};

export function provideAdvaniaStyles(): EnvironmentProviders {
    return makeEnvironmentProviders([
        providePrimeNG(defaults),
        MessageService,
        DialogService,
        provideIcons(),
        provideAppInitializer(() => {
            inject(AdvaniaThemeService);
        }),
    ]);
}
